import { Children, cloneElement, isValidElement, ReactNode } from 'react';

import cn from 'classnames';

import ToggleButton, { ToggleButtonProps } from './ToggleButton';
import useToggleButtonGroup, { UseToggleButtonGroup } from './vm';

export interface Props extends UseToggleButtonGroup {
  children: ReactNode;
  color?: 'info' | 'success' | 'error' | 'warning';
  className?: string;
}

const ToggleButtonGroup = ({ children: _children, color = 'info', className, ...vmProps }: Props) => {
  const { getIsSelected, toggleItem } = useToggleButtonGroup(vmProps);

  return (
    <div className={cn('toggle-button-group', `toggle-button-group__${color}`, className)}>
      {Children.map(_children, (child) => {
        if (isValidElement(child) && child.type === ToggleButton) {
          const overriddenProps: ToggleButtonProps = {
            ...child.props,
            disabled: vmProps.disabled || child.props.disabled,
            selected: getIsSelected(child.props.value),
            onClick: toggleItem(child.props.value),
          };
          return cloneElement(child, overriddenProps);
        }
        return child;
      })}
    </div>
  );
};

export default ToggleButtonGroup;
